import { CANCEL_API_REQUESTS } from '@/app/app.module';
import {
  HttpClient,
  HttpContext,
  HttpContextToken,
  HttpEvent,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, map, Observable, retry, throwError, last, takeUntil, Subject } from 'rxjs';
import { AuthService } from '../Auth/auth.service';
import {
  ApiErrorMessage,
  ApiResponse,
  ErrorApiReponse,
  SuccessApiResponse,
} from './ApiResponse';
import { HttpRequestMethod } from './HttpRequestMethod';
import { HttpRequestOptions } from './HttpRequestOptions';
export const IS_RETRY_ENABLED = new HttpContextToken<boolean>(() => true);
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(@Inject(HttpClient) private httpClient: HttpClient, @Inject(CANCEL_API_REQUESTS) private cancelApiRequests$: Observable<boolean>) { }

  createOptions<T>(
    method: HttpRequestMethod,
    headers: HttpHeaders,
    url: string,
    body: T | null,
    withCredentials: boolean = true,
    query: any = null,
    reportProgress = false
  ): HttpRequestOptions<T> {
    let options = new HttpRequestOptions<T>();
    options.requestMethod = method;
    options.headers = headers;
    options.reportProgress = reportProgress;
    if (reportProgress) {
      let event: any = 'events';
      options.observe = event;
    }
    options.requestUrl = url;
    options.body = body;
    options.params = query;
    options.withCredentials = withCredentials;
    return options;
  }

  createHeader(): HttpHeaders {
    let headers = new HttpHeaders();
    let token =
      localStorage.getItem('yib_tk');
    headers = headers.set(
      'Authorization',
      `Bearer ${token?.split('"').join('')}`
    );
    return headers;
  }
  execute<T>(
    requestOptions: HttpRequestOptions<T>,
    retry: boolean = true
  ): Observable<ApiResponse<T>> {
    return this.httpClient
      .request<T>(
        requestOptions.requestMethod.toString(),
        requestOptions.requestUrl,
        {
          body: requestOptions.body,
          context: new HttpContext().set(IS_RETRY_ENABLED, retry),
          headers: requestOptions.headers,
          reportProgress: requestOptions.reportProgress,
          observe: requestOptions.observe,
          params: requestOptions.params,
          responseType: requestOptions.responseType,
          withCredentials: requestOptions.withCredentials,
        }
      )
      .pipe(
        takeUntil(this.cancelApiRequests$),
        map((item) => {
          let response = new SuccessApiResponse<T>();
          response.results = item;
          return response;
        })
      );
  }

  upload<T>(requestOptions: HttpRequestOptions<T>): Observable<Object> {
    return this.httpClient.post(
      requestOptions.requestUrl,
      requestOptions.body,
      {
        headers: requestOptions.headers,
        reportProgress: requestOptions.reportProgress,
        observe: requestOptions.observe,
        params: requestOptions.params,
        responseType: requestOptions.responseType,
        withCredentials: requestOptions.withCredentials,
      }
    );
  }
}
